module.exports = __webpack_public_path__ + "static/logo-f430c9283701c32e739bd1d3137475f6.svg";